/**
 * 游戏卡片组件
 */
import { i18n } from '../core/I18n.js';

export class GameCard {
  constructor(gameConfig) {
    this.config = gameConfig;
  }
  
  /**
   * 渲染游戏卡片
   * @returns {HTMLElement}
   */
  render() {
    const lang = i18n.getLanguage();
    const name = this.config.name[lang] || this.config.name.zh;
    const desc = this.config.description[lang] || this.config.description.zh;
    const categoryLabel = i18n.t(`category.${this.config.category}`);
    
    const card = document.createElement('a');
    card.href = `/game/${this.config.id}`;
    card.className = 'game-card';
    card.setAttribute('data-category', this.config.category);
    card.setAttribute('data-game', this.config.id);
    
    card.innerHTML = `
      <div class="game-card-icon">${this.config.icon}</div>
      <h3 class="game-card-title">${name}</h3>
      <p class="game-card-desc">${desc}</p>
      <span class="game-card-category">${categoryLabel}</span>
    `;
    
    return card;
  }
}
